import React, { Component } from 'react';
import { connect } from 'react-redux';
import { helpRequest } from '../../../store/actions/customerServiceActions';

const formLabelStyle = {
    fontSize: "12px",
    fontWeight: "bold",
};

class ContactForm extends Component {
    constructor(props) {
        super(props)

        this.state = {
            senderName: "",
            senderEmail: "",
            senderReferenceNumber: "",
            senderMessage: "",
        }
    }

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { senderName, senderEmail, senderReferenceNumber, senderMessage } = this.state;
        this.props.helpRequest({
            name: senderName,
            email: senderEmail,
            anyReference: senderReferenceNumber,
            query: senderMessage,
        })
    }

    render() {
        const { customerService } = this.props;
        const { hepiMessage } = customerService;
        return (
            <div className="container">
                <div className="card">
                    <h5 className="card-header"><b>Any help needed?</b>
                        <p style={{fontSize: '13px', marginTop: '10px'}}>Use this form to contact us regarding inquiries, technical issues, or general support</p>
                    </h5>

                    <div className="card-body">
                        <form onSubmit={this.handleSubmit}>

                            {/* SENDER NAME */}
                            <div className="form-group text-left">
                                <label htmlFor="senderName" style={formLabelStyle}>Your name*</label>
                                <input type="text" className="form-control" id="senderName" onChange={this.handleChange} required readOnly={hepiMessage !== ''} />
                            </div>

                            {/* SENDER EMAIL */}
                            <div className="form-group text-left">
                                <label htmlFor="senderEmail" style={formLabelStyle}>Your email*</label>
                                <input type="email" className="form-control" id="senderEmail" onChange={this.handleChange} required readOnly={hepiMessage !== ''} />
                            </div>

                            {/* SENDER REF NUMBER */}
                            <div className="form-group text-left">
                                <label htmlFor="senderReferenceNumber" style={formLabelStyle}>Order or product id (if any)</label>
                                <input type="text" className="form-control" id="senderReferenceNumber" onChange={this.handleChange} readOnly={hepiMessage !== ''} />
                            </div>

                            {/* MESSAGE */}
                            <div className="form-group text-left">
                                <label htmlFor="senderMessage" style={formLabelStyle}>Type your query*</label>
                                <textarea type="text" className="form-control" id="senderMessage" onChange={this.handleChange} rows="4" cols="50" required readOnly={hepiMessage !== ''} />
                            </div>

                            {/* SEND BUTTON */}
                            {hepiMessage === '' ? <button className="btn btn-dark btn-sm" type="submit" disabled={hepiMessage !== ''}>{hepiMessage === '' ? 'Send query' : 'Query sent!'}</button> : <React.Fragment />}
                            <br />
                            <p style={{ fontSize: '16px' }}>{hepiMessage}</p>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        customerService: state.customerService,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        helpRequest: (helpData) => dispatch(helpRequest(helpData)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactForm)
